"use strict"; // Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var FullJitterBackoff_1 = require("../backoff/FullJitterBackoff");

var CSPMonitor_1 = require("../cspmonitor/CSPMonitor");

var Message_1 = require("../message/Message");

var DefaultReconnectController_1 = require("../reconnectcontroller/DefaultReconnectController");

var AsyncScheduler_1 = require("../scheduler/AsyncScheduler");

var DefaultSigV4_1 = require("../sigv4/DefaultSigV4");

var DefaultWebSocketAdapter_1 = require("../websocketadapter/DefaultWebSocketAdapter");

var WebSocketReadyState_1 = require("../websocketadapter/WebSocketReadyState");

var DefaultMessagingSession = /*#__PURE__*/function () {
  function DefaultMessagingSession(configuration, logger, webSocket, reconnectController, sigV4) {
    _classCallCheck(this, DefaultMessagingSession);

    this.configuration = configuration;
    this.logger = logger;
    this.webSocket = webSocket;
    this.reconnectController = reconnectController;
    this.sigV4 = sigV4;
    this.observerQueue = new Set();

    if (!this.webSocket) {
      this.webSocket = new DefaultWebSocketAdapter_1.default(this.logger);
    }

    if (!this.reconnectController) {
      this.reconnectController = new DefaultReconnectController_1.default(configuration.reconnectTimeoutMs, new FullJitterBackoff_1.default(configuration.reconnectFixedWaitMs, configuration.reconnectShortBackoffMs, configuration.reconnectLongBackoffMs));
    }

    if (!this.sigV4) {
      this.sigV4 = new DefaultSigV4_1.default(this.configuration.chimeClient, this.configuration.awsClient);
    }

    CSPMonitor_1.default.addLogger(this.logger);
    CSPMonitor_1.default.register();
  }

  _createClass(DefaultMessagingSession, [{
    key: "addObserver",
    value: function addObserver(observer) {
      this.logger.info('adding messaging observer');
      this.observerQueue.add(observer);
    }
  }, {
    key: "removeObserver",
    value: function removeObserver(observer) {
      this.logger.info('removing messaging observer');
      this.observerQueue.delete(observer);
    }
  }, {
    key: "start",
    value: function start() {
      if (this.isClosed()) {
        this.startConnecting(false);
      } else {
        this.logger.info('messaging session already started');
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      if (!this.isClosed()) {
        this.isClosing = true;
        this.webSocket.close();
        CSPMonitor_1.default.removeLogger(this.logger);
      } else {
        this.logger.info('no existing messaging session needs closing');
      }
    }
  }, {
    key: "forEachObserver",
    value: function forEachObserver(observerFunc) {
      var _this = this;

      var _iterator = _createForOfIteratorHelper(this.observerQueue),
          _step;

      try {
        var _loop = function _loop() {
          var observer = _step.value;
          AsyncScheduler_1.default.nextTick(function () {
            if (_this.observerQueue.has(observer)) {
              observerFunc(observer);
            }
          });
        };

        for (_iterator.s(); !(_step = _iterator.n()).done;) {
          _loop();
        }
      } catch (err) {
        _iterator.e(err);
      } finally {
        _iterator.f();
      }
    }
  }, {
    key: "setUpEventListeners",
    value: function setUpEventListeners() {
      var _this2 = this;

      this.webSocket.addEventListener('open', function () {
        _this2.openEventHandler();
      });
      this.webSocket.addEventListener('message', function (event) {
        _this2.receiveMessageHandler(event.data);
      });
      this.webSocket.addEventListener('close', function (event) {
        _this2.closeEventHandler(event);
      });
      this.webSocket.addEventListener('error', function () {
        _this2.logger.error("WebSocket error");
      });
    }
  }, {
    key: "startConnecting",
    value: function startConnecting(reconnecting) {
      var signedUrl = this.prepareWebSocketUrl();
      this.logger.info("opening connection to ".concat(signedUrl));

      if (!reconnecting) {
        this.reconnectController.reset();
      }

      if (this.reconnectController.hasStartedConnectionAttempt()) {
        this.reconnectController.startedConnectionAttempt(false);
      } else {
        this.reconnectController.startedConnectionAttempt(true);
      }

      this.webSocket.create(signedUrl, [], true);
      this.forEachObserver(function (observer) {
        if (observer.messagingSessionDidStartConnecting) {
          observer.messagingSessionDidStartConnecting(reconnecting);
        }
      });
      this.setUpEventListeners();
    }
  }, {
    key: "prepareWebSocketUrl",
    value: function prepareWebSocketUrl() {
      var queryParams = new Map();
      queryParams.set('userArn', [this.configuration.userArn]);
      queryParams.set('sessionId', [this.configuration.messagingSessionId]);
      return this.sigV4.signURL('GET', 'wss', 'chime', this.configuration.endpointUrl, '/connect', '', queryParams);
    }
  }, {
    key: "isClosed",
    value: function isClosed() {
      return this.webSocket.readyState() === WebSocketReadyState_1.default.None || this.webSocket.readyState() === WebSocketReadyState_1.default.Closed;
    }
  }, {
    key: "openEventHandler",
    value: function openEventHandler() {
      this.reconnectController.reset();
      this.isSessionEstablished = false;
    }
  }, {
    key: "receiveMessageHandler",
    value: function receiveMessageHandler(data) {
      try {
        var jsonData = JSON.parse(data);
        var messageType = jsonData.Headers['x-amz-chime-event-type'];
        var message = new Message_1.default(messageType, jsonData.Headers, jsonData.Payload || null);

        if (!this.isSessionEstablished && messageType === 'SESSION_ESTABLISHED') {
          // Backend connects WebSocket and then either
          // (1) Closes with WebSocket error code to reflect failure to authorize or other connection error OR
          // (2) Sends SESSION_ESTABLISHED. SESSION_ESTABLISHED indicates that all messages and events on a channel
          // the app instance user is a member of is guaranteed to be delivered on this WebSocket as long as the WebSocket
          // connection stays opened.
          this.forEachObserver(function (observer) {
            if (observer.messagingSessionDidStart) {
              observer.messagingSessionDidStart();
            }
          });
          this.isSessionEstablished = true;
        } else if (!this.isSessionEstablished) {
          // SESSION_ESTABLISHED is not guaranteed to be the first message, and in rare conditions a message or event from
          // a channel the member is a member of might arrive prior to SESSION_ESTABLISHED.  Because SESSION_ESTABLISHED indicates
          // it is safe to bootstrap the user application with out any race conditions in losing events we opt to drop messages prior
          // to SESSION_ESTABLISHED being received
          return;
        }

        this.forEachObserver(function (observer) {
          if (observer.messagingSessionDidReceiveMessage) {
            observer.messagingSessionDidReceiveMessage(message);
          }
        });
      } catch (error) {
        this.logger.error("Messaging parsing failed: ".concat(error));
      }
    }
  }, {
    key: "closeEventHandler",
    value: function closeEventHandler(event) {
      var _this3 = this;

      this.logger.info("WebSocket close: ".concat(event.code, " ").concat(event.reason));
      this.webSocket.destroy();

      if (!this.isClosing && this.canReconnect(event.code) && this.reconnectController.retryWithBackoff(function () {
        return __awaiter(_this3, void 0, void 0, /*#__PURE__*/_regenerator.default.mark(function _callee() {
          return _regenerator.default.wrap(function _callee$(_context) {
            while (1) {
              switch (_context.prev = _context.next) {
                case 0:
                  this.startConnecting(true);

                case 1:
                case "end":
                  return _context.stop();
              }
            }
          }, _callee, this);
        }));
      }, null)) {
        return;
      }

      this.isClosing = false;

      if (this.isSessionEstablished) {
        this.forEachObserver(function (observer) {
          if (observer.messagingSessionDidStop) {
            observer.messagingSessionDidStop(event);
          }
        });
      }
    }
  }, {
    key: "canReconnect",
    value: function canReconnect(closeCode) {
      // 4003 is Kicked closing event from the back end
      return closeCode === 1001 || closeCode === 1006 || closeCode >= 1011 && closeCode <= 1014 || closeCode > 4000 && closeCode !== 4002 && closeCode !== 4003 && closeCode !== 4401;
    }
  }]);

  return DefaultMessagingSession;
}();

exports.default = DefaultMessagingSession;